//AuthActions
export const AUTHENTICATE = 'authenticate';
export const AUTHENTICATE_SUCCESS = 'authenticate_success';
export const AUTHENTICATE_FAIL = 'authenticate_fail';
export const AUTHENTICATE_ACTIVE = 'authenticate_active';
export const AUTHENTICATE_ANONYMOUS = 'authenticate_anonymous';
export const AUTHENTICATE_ANONYMOUS_SUCCESS = 'authenticate_anonymous_success';
export const AUTHENTICATE_ANONYMOUS_FAIL = 'authenticate_anonymous_fail';

// PlayerActions
export const PLAYERS_FETCH = 'players_fetch';
export const PLAYERS_FETCH_SUCCESS = 'players_fetch_success';
export const PLAYERS_FETCH_FAIL = 'players_fetch_success';
export const PLAYERS_TOGGLE_EDIT = 'players_toggle_edit';
export const PLAYERS_EDIT_AVATAR_TEXT_CHANGE = 'players_edit_avatar_text_change';
export const PLAYERS_EDIT_FNAME_TEXT_CHANGE = 'players_edit_fname_text_change';
export const PLAYERS_EDIT_SURNAME_TEXT_CHANGE = 'players_edit_surname_text_change';
export const PLAYERS_EDIT_INITAL_TEXT_CHANGE = 'players_edit_inital_text_change';
export const PLAYERS_EDIT_POSITION_CHANGE = 'players_edit_position_change';
export const PLAYERS_EDIT_SQUAD_NUM_TEXT_CHANGE = 'players_edit_squad_num_text_change';
export const PLAYERS_UPDATE = 'players_update';
export const PLAYERS_UPDATE_SUCCESS = 'players_update_success';
export const PLAYERS_UPDATE_FAIL = 'players_update_fail';
export const PLAYERS_NEW = 'players_new';
export const PLAYERS_NEW_SUCCESS = 'players_new_success';
export const PLAYERS_NEW_FAIL = 'players_new_fail';
export const PLAYERS_DELETE = 'players_delete';
export const PLAYERS_DELETE_SUCCESS = 'players_delete_success';
export const PLAYERS_DELETE_FAIL = 'players_delete_fail';

// MatchActions
export const MATCH_FETCH = 'match_fetch';
export const MATCH_FETCH_SUCCESS = 'match_fetch_success';
export const MATCH_FETCH_FAIL = 'match_fetch_success';
export const MATCH_FETCH_DETAIL = 'match_detail_fetch';
export const MATCH_FETCH_DETAIL_SUCCESS = 'match_fetch_detail_success';
export const MATCH_FETCH_DETAIL_FAIL = 'match_fetch_detail_success';
export const MATCH_TOGGLE_EDIT = 'match_toggle_edit';
export const MATCH_EDIT_SEASONID_CHANGE = 'match_edit_seasonid_change';
export const MATCH_EDIT_POSTID_TEXT_CHANGE = 'match_edit_postid_text_change';
export const MATCH_EDIT_NAME_TEXT_CHANGE = 'match_edit_name_text_change';
export const MATCH_EDIT_DESC_TEXT_CHANGE = 'match_edit_desc_text_change';
export const MATCH_EDIT_FORMATION_CHANGE = 'match_edit_formation_text_change';
export const MATCH_EDIT_ACTIVE_CHANGE = 'match_edit_active_change';
export const MATCH_UPDATE = 'match_update';
export const MATCH_UPDATE_SUCCESS = 'match_update_success';
export const MATCH_UPDATE_FAIL = 'match_update_fail';
export const MATCH_NEW = 'match_new';
export const MATCH_NEW_SUCCESS = 'match_new_success';
export const MATCH_NEW_FAIL = 'match_new_fail';
export const MATCH_DELETE = 'match_delete';
export const MATCH_DELETE_SUCCESS = 'match_delete_success';
export const MATCH_DELETE_FAIL = 'match_delete_fail';
export const MATCH_EDIT_TEMP_FREEZE_CHANGE = 'match_edit_temp_freeze_change';
export const MATCH_EDIT_BONUS_TEXT_CHANGE = 'match_edit_bonus_text_change';

// MatchSquadActions
export const MATCH_SQUAD_REVIEW_CHANGE = 'match_squad_review_change';
export const MATCH_SQUAD_POSITION_CHANGE = 'match_squad_position_change';
export const MATCH_SQUAD_RATING_CHANGE = 'match_squad_rating_change';
export const MATCH_SQUAD_AVG_RATING_CHANGE = 'match_squad_avg_rating_change';
export const MATCH_SQUAD_GOAL_CHANGE = 'match_squad_goal_change';
export const MATCH_SQUAD_CARD_CHANGE = 'match_squad_card_change';
export const MATCH_SQUAD_TOGGLE_EDIT = 'match_squad_toggle_edit';
export const MATCH_SQUAD_FETCH = 'match_squad_fetch';
export const MATCH_SQUAD_FETCH_SUCCESS = 'match_squad_fetch_success';
export const MATCH_SQUAD_FETCH_FAIL = 'match_squad_fetch_fail';
export const MATCH_SQUAD_UPDATE = 'match_squad_update';
export const MATCH_SQUAD_UPDATE_SUCCESS = 'match_squad_update_success';
export const MATCH_SQUAD_UPDATE_FAIL = 'match_squad_update_fail';
export const MATCH_SQUAD_NEW = 'match_squad_new';
export const MATCH_SQUAD_NEW_SUCCESS = 'match_squad_new_success';
export const MATCH_SQUAD_NEW_FAIL = 'match_squad_new_fail';
export const MATCH_SQUAD_DELETE = 'match_squad_delete';
export const MATCH_SQUAD_DELETE_SUCCESS = 'match_squad_delete_success';
export const MATCH_SQUAD_DELETE_FAIL = 'match_squad_delete_fail';
export const MATCH_SQUAD_ADD_PLAYER = 'match_squad_add_player';
export const MATCH_SQUAD_ADD_PLAYER_SUCCESS = 'match_squad_add_player_success';
export const MATCH_SQUAD_ADD_PLAYER_FAIL = 'match_squad_add_player_fail';
export const MATCH_SQUAD_DELETE_PLAYER = 'match_squad_delete_player';
export const MATCH_SQUAD_DELETE_PLAYER_SUCCESS = 'match_squad_delete_player_success';
export const MATCH_SQUAD_DELETE_PLAYER_FAIL = 'match_squad_delete_player_fail';
export const MATCH_SQUAD_INPUT_PLAYER = 'match_squad_input_player';
export const MATCH_SQUAD_INPUT_POSITION = 'match_squad_input_position';
export const MATCH_SQUAD_INPUT_GOAL = 'match_squad_input_goal';
export const MATCH_SQUAD_INPUT_CARD = 'match_squad_input_card';
export const MATCH_SQUAD_INPUT_MATCH_RATING = 'match_squad_input_match_rating';
export const MATCH_SQUAD_INPUT_REVIEW = 'match_squad_input_review';

export const USER_RATING_ADD = 'user_rating_add';
export const USER_RATING_ADD_SUCCESS = 'user_rating_add_success';
export const USER_RATING_ADD_FAIL = 'user_rating_add_fail';
export const USER_RATING_ADD_VOTE = 'user_rating_add_vote';
export const USER_RATINGS_FETCH = 'USER_RATINGS_FETCH';
export const USER_RATINGS_FETCH_SUCCESS = 'user_ratings_fetch_success';
export const USER_RATING_GET_MATCH = 'user_rating_get_match';
export const USER_RATING_GET_MATCH_SUCCESS = 'user_rating_get_match_success';
export const USER_RATING_UPDATE_REVEAL_SUCCESS = 'user_rating_update_reveal_success';
export const USER_RATING_UPDATE_REVEAL = 'user_rating_update_reveal';

export const BROWSER_FINGERPRINT_FETCH = 'browser_fingerprint_fetch';
export const BROWSER_FINGERPRINT_FETCH_SUCCESS = 'browser_fingerprint_fetch_success';
export const BROWSER_FINGERPRINT_ADD = 'browser_fingerprint_add';
export const BROWSER_FINGERPRINT_ADD_SUCCESS = 'browser_fingerprint_add_success';



// WEBPACK FOOTER //
// ./src/actions/types.js